var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/client-env.ts
var CLIENT_ENV_PREFIX = "NEXT_PUBLIC_";
var SERVER_ENV_PREFIX = "";
var CLIENT_ENV_KEYS = [
  "NEXT_PUBLIC_APP_URL",
  "NEXT_PUBLIC_APP_NAME",
  "NEXT_PUBLIC_APP_DESCRIPTION",
  "NEXT_PUBLIC_ENVIRONMENT",
  "NEXT_PUBLIC_API_BASE_URL",
  "NEXT_PUBLIC_AUTH_BASE_URL",
  "NEXT_PUBLIC_ANALYTICS_BASE_URL",
  "NEXT_PUBLIC_KINDE_AUDIENCE",
  "NEXT_PUBLIC_KINDE_ISSUER_URL",
  "NEXT_PUBLIC_KINDE_POST_LOGOUT_REDIRECT_URL",
  "NEXT_PUBLIC_KINDE_CONNECTION_EMAIL",
  "NEXT_PUBLIC_KINDE_CONNECTION_GITHUB",
  "NEXT_PUBLIC_KINDE_CONNECTION_GOOGLE",
  "NEXT_PUBLIC_KINDE_CONNECTION_LINKEDIN",
  "NEXT_PUBLIC_KINDE_CONNECTION_MICROSOFT",
  "NEXT_PUBLIC_STACK_PROJECT_ID",
  "NEXT_PUBLIC_STACK_PUBLISHABLE_CLIENT_KEY",
  "NEXT_PUBLIC_SUPABASE_URL",
  "NEXT_PUBLIC_SUPABASE_ANON_KEY",
  "NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY",
  "NEXT_PUBLIC_METICULOUS_PROJECT_ID",
  "NEXT_PUBLIC_SENTRY_DSN",
  "NEXT_PUBLIC_GA_ID",
  "NEXT_PUBLIC_GA_MEASUREMENT_ID",
  "NEXT_PUBLIC_GOOGLE_ANALYTICS_ID",
  "NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID",
  "NEXT_PUBLIC_VERCEL_ANALYTICS_ID",
  "NEXT_PUBLIC_MIXPANEL_TOKEN",
  "NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN",
  "NEXT_PUBLIC_POSTHOG_KEY",
  "NEXT_PUBLIC_POSTHOG_HOST",
  "NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY",
  "NEXT_PUBLIC_FLUTTERWAVE_PUBLIC_KEY",
  "NEXT_PUBLIC_TRIGGER_PUBLIC_API_KEY",
  "NEXT_PUBLIC_PUSHER_APP_ID",
  "NEXT_PUBLIC_PUSHER_KEY",
  "NEXT_PUBLIC_PUSHER_SECRET",
  "NEXT_PUBLIC_PUSHER_CLUSTER",
  "NEXT_PUBLIC_REALTIME_PROVIDER",
  "NEXT_PUBLIC_ABLY_KEY",
  "NEXT_PUBLIC_VAPID_PUBLIC_KEY",
  "NEXT_PUBLIC_REALTIME_STORE",
  "NEXT_PUBLIC_TERMLY_PROJECT_ID",
  "NEXT_PUBLIC_TERMLY_AUTO_BLOCK",
  "NEXT_PUBLIC_ENABLE_PWA",
  "NEXT_PUBLIC_ENABLE_AI_FEATURES",
  "NEXT_PUBLIC_ENABLE_ANALYTICS",
  "NEXT_PUBLIC_ENABLE_MONITORING",
  "NEXT_PUBLIC_DEV_MODE",
  "NEXT_PUBLIC_ENABLE_PERFORMANCE_INSIGHTS",
  "NEXT_PUBLIC_THEME_DEFAULT",
  "NEXT_PUBLIC_SHOW_SCROLL_TO_TOP",
  "NEXT_PUBLIC_E2E_MODE",
  "NEXT_PUBLIC_BUILD_ID",
  "NEXT_PUBLIC_VERCEL_URL",
  "NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA",
  "NEXT_PUBLIC_VERCEL_ENV",
  "NEXT_PUBLIC_URL"
];
function getRawEnv() {
  if ("EdgeRuntime" in globalThis) {
    return {};
  }
  return typeof process !== "undefined" ? process.env : {};
}
__name(getRawEnv, "getRawEnv");
function hasRawEnv(key) {
  if ("EdgeRuntime" in globalThis) {
    return false;
  }
  const value = typeof process !== "undefined" ? process.env[key] : void 0;
  return value !== null && value !== void 0 && value !== "";
}
__name(hasRawEnv, "hasRawEnv");
function getClientEnv() {
  if (typeof process === "undefined") {
    return {};
  }
  return {
    // Core App
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_APP_DESCRIPTION: process.env.NEXT_PUBLIC_APP_DESCRIPTION,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    // API URLs
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_AUTH_BASE_URL: process.env.NEXT_PUBLIC_AUTH_BASE_URL,
    NEXT_PUBLIC_ANALYTICS_BASE_URL: process.env.NEXT_PUBLIC_ANALYTICS_BASE_URL,
    // Auth
    NEXT_PUBLIC_KINDE_AUDIENCE: process.env.NEXT_PUBLIC_KINDE_AUDIENCE,
    NEXT_PUBLIC_KINDE_ISSUER_URL: process.env.NEXT_PUBLIC_KINDE_ISSUER_URL,
    NEXT_PUBLIC_KINDE_POST_LOGOUT_REDIRECT_URL: process.env.NEXT_PUBLIC_KINDE_POST_LOGOUT_REDIRECT_URL,
    // Kinde Connection IDs
    NEXT_PUBLIC_KINDE_CONNECTION_EMAIL: process.env.NEXT_PUBLIC_KINDE_CONNECTION_EMAIL,
    NEXT_PUBLIC_KINDE_CONNECTION_GITHUB: process.env.NEXT_PUBLIC_KINDE_CONNECTION_GITHUB,
    NEXT_PUBLIC_KINDE_CONNECTION_GOOGLE: process.env.NEXT_PUBLIC_KINDE_CONNECTION_GOOGLE,
    NEXT_PUBLIC_KINDE_CONNECTION_LINKEDIN: process.env.NEXT_PUBLIC_KINDE_CONNECTION_LINKEDIN,
    NEXT_PUBLIC_KINDE_CONNECTION_MICROSOFT: process.env.NEXT_PUBLIC_KINDE_CONNECTION_MICROSOFT,
    // Stack Auth
    NEXT_PUBLIC_STACK_PROJECT_ID: process.env.NEXT_PUBLIC_STACK_PROJECT_ID,
    NEXT_PUBLIC_STACK_PUBLISHABLE_CLIENT_KEY: process.env.NEXT_PUBLIC_STACK_PUBLISHABLE_CLIENT_KEY,
    // Database
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY: process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY,
    // Monitoring & Debugging
    NEXT_PUBLIC_METICULOUS_PROJECT_ID: process.env.NEXT_PUBLIC_METICULOUS_PROJECT_ID,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    // Analytics
    NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
    NEXT_PUBLIC_GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    NEXT_PUBLIC_VERCEL_ANALYTICS_ID: process.env.NEXT_PUBLIC_VERCEL_ANALYTICS_ID,
    NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    // Payments
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    NEXT_PUBLIC_FLUTTERWAVE_PUBLIC_KEY: process.env.NEXT_PUBLIC_FLUTTERWAVE_PUBLIC_KEY,
    // Background Jobs (Trigger.dev)
    NEXT_PUBLIC_TRIGGER_PUBLIC_API_KEY: process.env.NEXT_PUBLIC_TRIGGER_PUBLIC_API_KEY,
    // Realtime & WebSockets
    NEXT_PUBLIC_PUSHER_APP_ID: process.env.NEXT_PUBLIC_PUSHER_APP_ID,
    NEXT_PUBLIC_PUSHER_KEY: process.env.NEXT_PUBLIC_PUSHER_KEY,
    NEXT_PUBLIC_PUSHER_SECRET: process.env.NEXT_PUBLIC_PUSHER_SECRET,
    NEXT_PUBLIC_PUSHER_CLUSTER: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    NEXT_PUBLIC_REALTIME_PROVIDER: process.env.NEXT_PUBLIC_REALTIME_PROVIDER,
    NEXT_PUBLIC_ABLY_KEY: process.env.NEXT_PUBLIC_ABLY_KEY,
    NEXT_PUBLIC_VAPID_PUBLIC_KEY: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
    NEXT_PUBLIC_REALTIME_STORE: process.env.NEXT_PUBLIC_REALTIME_STORE,
    // Legal & Compliance
    NEXT_PUBLIC_TERMLY_PROJECT_ID: process.env.NEXT_PUBLIC_TERMLY_PROJECT_ID,
    NEXT_PUBLIC_TERMLY_AUTO_BLOCK: process.env.NEXT_PUBLIC_TERMLY_AUTO_BLOCK,
    // Feature Flags
    NEXT_PUBLIC_ENABLE_PWA: process.env.NEXT_PUBLIC_ENABLE_PWA,
    NEXT_PUBLIC_ENABLE_AI_FEATURES: process.env.NEXT_PUBLIC_ENABLE_AI_FEATURES,
    NEXT_PUBLIC_ENABLE_ANALYTICS: process.env.NEXT_PUBLIC_ENABLE_ANALYTICS,
    NEXT_PUBLIC_ENABLE_MONITORING: process.env.NEXT_PUBLIC_ENABLE_MONITORING,
    NEXT_PUBLIC_DEV_MODE: process.env.NEXT_PUBLIC_DEV_MODE,
    NEXT_PUBLIC_ENABLE_PERFORMANCE_INSIGHTS: process.env.NEXT_PUBLIC_ENABLE_PERFORMANCE_INSIGHTS,
    // Theme
    NEXT_PUBLIC_THEME_DEFAULT: process.env.NEXT_PUBLIC_THEME_DEFAULT,
    // UI Features
    NEXT_PUBLIC_SHOW_SCROLL_TO_TOP: process.env.NEXT_PUBLIC_SHOW_SCROLL_TO_TOP,
    // E2E Testing
    NEXT_PUBLIC_E2E_MODE: process.env.NEXT_PUBLIC_E2E_MODE,
    // Build Info
    NEXT_PUBLIC_BUILD_ID: process.env.NEXT_PUBLIC_BUILD_ID,
    // Platform Info
    NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
    NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL
  };
}
__name(getClientEnv, "getClientEnv");
var CLIENT_DEFAULTED_FLAG_DEFAULTS = {
  NEXT_PUBLIC_ENABLE_AI_FEATURES: "true",
  NEXT_PUBLIC_ENABLE_ANALYTICS: "true",
  /** When true, enables Speed Insights and Performance Monitor (optional extras alongside PostHog). */
  NEXT_PUBLIC_ENABLE_PERFORMANCE_INSIGHTS: "false"
};
var CLIENT_OPTIONAL_FLAG_KEYS = [
  "NEXT_PUBLIC_TERMLY_AUTO_BLOCK",
  "NEXT_PUBLIC_ENABLE_PWA",
  "NEXT_PUBLIC_ENABLE_MONITORING",
  "NEXT_PUBLIC_DEV_MODE",
  "NEXT_PUBLIC_SHOW_SCROLL_TO_TOP",
  "NEXT_PUBLIC_E2E_MODE"
];
var CLIENT_THEME_DEFAULT = "system";
function isDefaultedFlagKey(key) {
  return key in CLIENT_DEFAULTED_FLAG_DEFAULTS;
}
__name(isDefaultedFlagKey, "isDefaultedFlagKey");
function isOptionalFlagKey(key) {
  return CLIENT_OPTIONAL_FLAG_KEYS.includes(key);
}
__name(isOptionalFlagKey, "isOptionalFlagKey");
function parseClientEnvValue(key, rawValue) {
  const value = rawValue === "" ? void 0 : rawValue;
  if (isDefaultedFlagKey(key)) {
    return (value ?? CLIENT_DEFAULTED_FLAG_DEFAULTS[key]) === "true";
  }
  if (isOptionalFlagKey(key)) {
    return value === void 0 ? void 0 : value === "true";
  }
  if (key === "NEXT_PUBLIC_THEME_DEFAULT") {
    return value ?? CLIENT_THEME_DEFAULT;
  }
  return value;
}
__name(parseClientEnvValue, "parseClientEnvValue");
var SERVER_ENV_ACCESS_ON_CLIENT_MESSAGE = "❌ Attempted to access a server-side e\
nvironment variable on the client";
function isClientEnvKeyName(name) {
  return name.startsWith(CLIENT_ENV_PREFIX);
}
__name(isClientEnvKeyName, "isClientEnvKeyName");
function createClientEnvironment(rawValues) {
  const parsed = {};
  for (const key of CLIENT_ENV_KEYS) {
    const value = parseClientEnvValue(key, rawValues[key]);
    if (value !== void 0) {
      parsed[key] = value;
    }
  }
  return new Proxy(parsed, {
    get(target, property) {
      if (typeof property !== "string" || property === "__esModule" || property ===
      "$$typeof") {
        return void 0;
      }
      if (!isClientEnvKeyName(property)) {
        throw new Error(SERVER_ENV_ACCESS_ON_CLIENT_MESSAGE);
      }
      return Reflect.get(target, property);
    }
  });
}
__name(createClientEnvironment, "createClientEnvironment");
export {
  CLIENT_DEFAULTED_FLAG_DEFAULTS,
  CLIENT_ENV_KEYS,
  CLIENT_ENV_PREFIX,
  CLIENT_OPTIONAL_FLAG_KEYS,
  CLIENT_THEME_DEFAULT,
  SERVER_ENV_ACCESS_ON_CLIENT_MESSAGE,
  SERVER_ENV_PREFIX,
  createClientEnvironment,
  getClientEnv,
  getRawEnv,
  hasRawEnv,
  isClientEnvKeyName,
  parseClientEnvValue
};
